/**
 * Shared application constants.
 */
export const PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
export const MAX_PER_PAGE = 200;

// HTTP status codes
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_CONFLICT = 409;
export const HTTP_TOO_MANY = 429;

// Auth
export const ACCESS_TOKEN_STORAGE_KEY = "access_token";

// Pricing
export const DEFAULT_MARKUP_PERCENT = 35;
export const DEFAULT_ROUNDING = "99";
export const ROUNDING_RULES = [
  { v: "none", l: "Без округления" },
  { v: "99", l: "До .99" },
  { v: "95", l: "До .95" },
  { v: "90", l: "До .90" },
  { v: "integer", l: "До целого" },
  { v: "up", l: "Вверх (ceil)" },
  { v: "down", l: "Вниз (floor)" },
];
